/**
 * Transforms a string of words into a single lower camelCase word
 * eg, Create Task -> createTask
 */
export const toLowerCamelCase = (input: string) => {
	const trimmedInput = input.trim();
	const words = trimmedInput.split(' ');

	const camelCasedWords = words.map((word, index) => {
		// Convert the first word to lowercase
		if (index === 0) {
			return word.toLowerCase();
		}
		return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
	});

	return camelCasedWords.join('');
};
